import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export class Loader {

  public show = false;
  public text = '';
  public timeInSeconds = 0;

  constructor(showLoader: boolean, loaderText: string, time = 0) {
    this.show = showLoader;
    this.text = loaderText;
    this.timeInSeconds = time;
  }

}

export class LoaderSession {
  show: boolean;
  counter: number;
  constructor(showLoader: boolean, count: number) {
    this.show = showLoader;
    this.counter = count;
  }
}

@Injectable()
export class LoaderService {

  public ShowLoaderSource = new Subject<Loader>();
  toggleLoader$: any = this.ShowLoaderSource.asObservable();

  constructor() { }

}
